export default {
  marshal: (data) => {
    return {
      active: data.terms !== null && Array.isArray(data.terms) && data.terms.length > 0,
      steps: data.terms || [],
    };
  },
};
